import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from 'assets/images/logo.svg';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import { resetPassword } from 'api/api';
import { ResetPassword } from 'components/forgotPassword';

export const ResetPasswordNewManager = ({ userEmail, domain, verifiedCode }) => {
  const navigate = useNavigate();

  const handleResetPassword = async (password) => {
    const formData = { email: userEmail, passwd: password, code: verifiedCode };
    const res = await resetPassword(formData, domain);

    if (res.status === 201) {
      toast.success('Password changed successfully');
      return navigate('/');
    }
  };

  return (
    <div className="flex flex-col bg-white rounded-[60px] pt-10 pb-12 w-[40rem] h-[calc(100%-64px)] min-h-[46rem] my-8 relative">
      <img className="w-48 mb-6 self-center" src={Logo} alt="pw25 logo" />
      <div
        className={classNames(
          'flex-1 relative w-full flex flex-col py-8 border-b border-t border-color-divider px-20 self-center items-center',
          'before:content-[""] before:absolute before:w-4 before:h-4 before:rounded-full before:border before:border-color-divider before:bg-white before:z-10 before:top-0 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2',
          'after:content-[""] after:absolute after:w-4 after:h-4 after:rounded-full after:border after:border-color-divider after:bg-white after:z-10 after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:translate-y-1/2',
        )}
      >
        <p className="mb-4 nunito-title">Reset Password</p>
        <p className="text-lightBlue text-base leading-[24px] max-w-[350px] text-center">
          Set the new password for Your account
        </p>
        <ResetPassword reset={handleResetPassword} />
      </div>
    </div>
  );
};
